import * as React from "react";
import { RequestContext } from "../lib/request-context.ts";
declare global {
  interface Window {
    ENV: Props;
  }
}

export type Props = {
  SENTRY_DSN: string;
  STRIPE_PUBLIC_KEY: string;
  APP_ENV: string;
  APP_VERSION: string | undefined;
};

export function getPublicEnv<T extends keyof Props>(key: T): Props[T] {
  return typeof document === "undefined" ? Deno.env.get(key)! : window.ENV[key];
}

// API binding for render() helper
export async function ENV(
  ctx: RequestContext,
  _params: Props,
) {
  return _params;
}

export function PublicEnv(props: Props) {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `window.ENV = ${JSON.stringify(props)}`,
      }}
    />
  );
}
